type GroupResult<T> = { groupKey: string; items: T[] }[];

export class h {
  public static each<T>(
    items: T[],
    eachFn: (item: T, index: number) => void,
  ): void {
    if (!items) return;
    items.forEach((value, index1) => eachFn(value, index1));
  }

  public static find<T>(
    items: T[],
    eachFn: (item: T, index: number) => boolean,
  ): T {
    if (!items) return (null as unknown) as T;
    const item = items.find((value, index1) =>
      eachFn(value, index1),
    );
    return item || ((null as unknown) as T);
  }

  // đừng dùng hàm này nữa, dùng hàm indexOf nhé;
  public static index<T>(
    items: T[],
    item: T,
    compareFn: (item1: T, item2: T) => boolean,
  ): number {
    return !items
      ? -1
      : items.findIndex(value => compareFn(item, value));
  }

  public static indexOf<T>(
    items: T[],
    compareFn: (item: T, index: number) => boolean,
  ): number {
    return !items
      ? -1
      : items.findIndex((value, index1) =>
          compareFn(value, index1),
        );
  }

  public static exists<T>(
    items: T[],
    compareFn: (item: T, index: number) => boolean,
  ): boolean {
    return h.indexOf(items, compareFn) !== -1;
  }

  public static findAll<T>(
    items: T[],
    eachFn: (item: T, index: number) => boolean,
  ): T[] {
    return !items
      ? []
      : items.filter((value, index1) =>
          eachFn(value, index1),
        );
  }

  public static count<T>(
    items: T[],
    eachFn: (item: T, index: number) => boolean,
  ): number {
    let count = 0;
    if (items) {
      items.forEach((value, index1) => {
        if (eachFn(value, index1)) count++;
      });
    }
    return count;
  }

  public static collect<T, T1>(
    items: T[],
    eachFn: (item: T, index: number) => T1,
  ): T1[] {
    return !items
      ? []
      : items.map((value, index1) => eachFn(value, index1));
  }

  public static sum<T>(
    items: T[],
    eachFn: (item: T, index: number) => number,
  ): number {
    let sum = 0;
    if (items) {
      items.forEach((value, index1) => {
        sum += eachFn(value, index1);
      });
    }
    return sum;
  }

  public static max<T>(
    items: T[],
    compareFn: (item: T, item2: T) => number,
  ): T | null {
    if (!items || !items.length) return null;
    let maxItem: T | null = null;
    items.forEach(value => {
      if (!maxItem || compareFn(maxItem, value) < 0) {
        maxItem = value;
      }
    });
    return maxItem;
  }

  public static group<T>(
    items: T[],
    groupByFn: (item: T) => any,
    groupLabel: (item: T) => string,
  ): GroupResult<T> {
    if (!groupLabel) groupLabel = groupByFn;

    const groupKeys: any[] = [];
    const groups: GroupResult<T> = [];

    h.each(items, item => {
      const groupKey = groupByFn(item);
      const index = groupKeys.indexOf(groupKey);
      if (index === -1) {
        groupKeys.push(groupKey);
        groups.push({
          groupKey: groupLabel(item),
          items: [item],
        });
      } else {
        groups[index].items.push(item);
      }
    });

    return groups;
  }
}
